import {Component, OnDestroy, OnInit} from "@angular/core";
import {CirfService} from "../cirf.service";
import {FormControl, FormGroup} from "@angular/forms";
import {Cirf} from "../cirf";
import {CirfConfigService} from "../config/cirf-config-service";

@Component({
    selector: 'dp-new-mortgage-note',
    templateUrl: './new-mortgage-note.component.html'
})
export class NewMortgageNoteComponent implements OnInit, OnDestroy {
    showMortgageNotesStep: boolean;
    mortgageNotesFieldKey: string;

    constructor(public cirfService : CirfService,
                private cirfConfigService: CirfConfigService) { }

    ngOnInit() {
        this.mortgageNotesFieldKey = 'newMortgage.mortgageNotes';
        this.showMortgageNotesStep = !this.cirfConfigService.isFieldHidden(this.mortgageNotesFieldKey);
        this.onChanges();
    }

    get cirfFormGroup() : FormGroup{
        return (this.cirfService.cirfFormGroup as FormGroup);
    }

    ngOnDestroy() : void {
        this.cirfService.updateCirf('INPROGRESS');
    }

    onChanges(): void {
        this.cirfService.saveChangesOnCirfFormChanges();
    }
}
